import { useEffect, useRef } from 'react';

export const useCallOnceWhen = (condition, callback) => {
  const hasCalledRef = useRef(false);
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (hasCalledRef.current) return;
    if (!condition) return;
    hasCalledRef.current = true;
    callbackRef.current?.();
  }, [condition]);
};
